import * as React from 'react'
import Modal from '@mui/material/Modal'
import Button from '@mui/material/Button'
import CustomView from './CustomView'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import CloseIcon from '@mui/icons-material/Close';
import CustomGraphy from './CustomGraphy'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useFilterModal } from '@/hooks/useCustomFilter'

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'auto',
  borderRadius: '8px',
  border: '1.5px solid #C4C4C4',
  boxShadow: 24,
  p: 4,
  maxHeight: '75vh',
  overflow: 'auto'
}

interface IFilterModal {
  children: React.ReactNode
}

function CustomFilterModal({ children }: IFilterModal) {
  const { open, handleClose, handleOpen } = useFilterModal()

  const mobile = useMediaQuery('(max-width:991px)')

  return (
    <CustomView width="unset">
      <Button
        startIcon={<FilterAltIcon />}
        variant="outlined"
        onClick={handleOpen}
        style={{
          width: mobile ? '100%' : '100px',
          height: '44px',
          textTransform: 'capitalize',
          fontSize: '14px',
          color: '#2E363E',
          border: '1.5px solid #C4C4C4'
        }}
      >
        Filtros
      </Button>
      <Modal keepMounted open={open} onClose={handleClose}>
        <CustomView backColor="white" sx={style} style={{ minWidth: mobile ? '100%' : '400px' }}>
          <>
            <CustomView flexDirection='row' justifyContent='space-between' style={{ borderBottom: '1px solid #f8f8f8', padding: '5px' }}>
              <CustomGraphy fontSize={20}>Filtros</CustomGraphy>
              <CustomView onClick={handleClose} style={{ cursor: 'pointer', color: '#2C2C2C' }} width='unset'><CloseIcon fontSize='large' /></CustomView>
            </CustomView>
            {children}
          </>
        </CustomView>
      </Modal>
    </CustomView>
  )
}

export default CustomFilterModal
